// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionFeaturedListings_title__2ZT12","listings":"SectionFeaturedListings_listings__r0YNU","listingCard":"SectionFeaturedListings_listingCard__1URPY"};